module.exports = {"Phase":{"Basement":[],"E1":[],"E2":[]}}


//////////////////
// WEBPACK FOOTER
// ./src/data/glasswaterLocks.json
// module id = 116
// module chunks = 0